import React from 'react';

import Footer from '../Footer/Footer';

import FooterBrandMark from './FooterBrandMark';
import FooterCopyrightBand from './FooterCopyrightBand';
import { footerThemeToBrandMarkVariant, type FooterTheme } from './footerTheme';

type FooterProps = React.ComponentProps<typeof Footer>;

interface MarketingPageFooterProps extends Omit<FooterProps, 'theme'> {
  theme?: FooterTheme;
}

/**
 * Wrangle-style marketing footer stack:
 * 1. Link columns (card)
 * 2. Copyright band (full-width gray strip)
 * 3. Oversized mesh wordmark (gradient inside letters only)
 */
const MarketingPageFooter: React.FC<MarketingPageFooterProps> = ({
  theme = 'home',
  ...footerProps
}) => (
  <div className="marketing-page-footer">
    <Footer {...footerProps} theme={theme} />
    <FooterCopyrightBand theme={theme} />
    <FooterBrandMark variant={footerThemeToBrandMarkVariant(theme)} />
  </div>
);

export default React.memo(MarketingPageFooter);
